// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import variables from '@/styles/element-variables.scss'
import '@/utils/plugins';
import '@/utils/components';
import axios from 'axios'
import { Message } from 'element-ui'
Vue.config.productionTip = false

// 更改网页标题
Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
});

// 获取代理商信息 
async function getAgentInfo(){
  // const res = await axios.get(`${process.env.BASE_API}/2928892/welcome/agent_info?auth_code=abcde`)  //本地测试
  const res = await axios.get(`/api/welcome/agent_info`)
  if(res.data.code === '100001'){
      let agentInfo = res.data.result;
      //加上代理商独有前缀
      // axios.defaults.baseURL = process.env.BASE_API + '/' +  agentInfo.distSpId + '/app';
      //传入代理商信息
      store.dispatch('setAgentInfo', agentInfo);
  } else {
    Message.error(res.data.message)
  }
}
getAgentInfo()

setTimeout(()=>{
  new Vue({
    el: '#app',
    name: 'root',
    provide(){
      return {
        themeConfig: this
      }
    },
    data() {
      return {
        themeColor: variables.colorPrimary.toLowerCase(),
        defaultColor: variables.colorPrimary.toLowerCase(),
        themeFirstLoaded: true, // 主题是否第一次加载，解决初始主题watch跟$route执行setThemeColor两次问题
      }
    },
    created() {
      this.$on('root.config',(result,themeFirstLoaded) => {
        this.themeColor = result.toLowerCase();
        this.themeFirstLoaded = themeFirstLoaded;
      })
    },
    watch: {
      themeColor(newval, oldval) {
        if(!this.themeFirstLoaded) {
          this.setThemeColor(newval, oldval);
        }
      }
    },
    router,
    store,
    components: { App },
    template: '<App/>'
  })
},300)



// WEBPACK FOOTER //
// ./src/main.js